<template>
  <div class="scroll-height overflow-y-auto">
    <!-- 제목 -->
    <v-row class="title-wrap">
      <v-col cols="12" class="icon-title">
        <appl-menu-icon
          :propsParam="{
            applCd: GET_SEARCH_APPL_CD,
            gntGubunCd: GET_GNT_GUBUN_CD,
          }"
        />
        {{ menuTitle }}
      </v-col>
      <v-col cols="12" class="pt-0 px-6 title-desc" v-if="isReward">
        <!-- 가능일수  -->
        <v-chip label class="chip-desc" color="#E8F9ED">
          <span>
            {{ $t('현재 신청 가능 시간은') }}
            {{ GET_REWARD_TOTAL_REST_TIME }}{{ $t('시간입니다') }}
          </span>
        </v-chip>
      </v-col>
    </v-row>

    <v-list v-if="!emptyDataFlag" class="gntType-list">
      <v-list-item-group color="primary">
        <v-list-item
          v-for="(item, i) in GET_GNT_CD_LIST"
          :key="i"
          class="gntType-item"
        >
          <v-list-item-content @click="selectGntCd(item)">
            <v-list-item-title class="gntType-title" v-text="item.codeNm" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <!-- empty Data component -->
    <no-applicable v-if="emptyDataFlag" v-bind:text="emptyDataText" />
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import NoApplicable from '@/components/common/NoApplicable.vue';
import ApplMenuIcon from '@/components/application/form/ApplMenuIcon.vue';
import routerNames from '@/const/routerConstants';
import applCdMixin from '@/mixins/applCdMixin.js';

export default {
  mixins: [applCdMixin],
  data: () => ({
    emptyDataFlag: false,
  }),
  computed: {
    ...mapGetters('CODE', ['GET_GNT_CD_LIST']),
    ...mapGetters('ELA', [
      'GET_GNT_GUBUN_CD',
      'GET_SEARCH_APPL_CD',
      'GET_APP_MENU',
      'GET_GNT_CD',
      'GET_REWARD_TOTAL_REST_TIME',
    ]),

    /* 메뉴 제목 */
    menuTitle() {
      const gntGubunCd = this.GET_APP_MENU.gntGubunCd;
      if (this.isVacation && (gntGubunCd == '1' || gntGubunCd == '41')) {
        return this.$i18n.t('휴가종류를 선택해주세요.');
      } else if (this.isReward) {
        return this.$i18n.t('보상휴가 종류를 선택해주세요.');
      } else {
        return this.$i18n.t('근태명을 선택해주세요.');
      }
    },
  },

  methods: {
    ...mapMutations('ELA', [
      'SET_HALF_YN',
      'SET_GNT_CD',
      'SET_S_YMD',
      'SET_E_YMD',
      'SET_GNT_GUBUN_CD',
      'SET_APPL_ORG_LVL',
    ]),

    async selectGntCd(gntCd) {
      this.SET_GNT_CD(gntCd);
      this.SET_HALF_YN();
      this.SET_APPL_ORG_LVL(gntCd.orgLvl); // 신청서의 예외 결재레벨 분리저장

      // 휴가 잔여 일자 조회
      if (gntCd.gntCdDel !== null) {
        this.SET_S_YMD(this.todayYMD);
        this.SET_E_YMD(this.todayYMD);

        await this.$store.dispatch('ELA/FETCH_REST_CNT');
      }
      this.$router.push(routerNames.StartDate);
    },

    /* 근태명 목록 조회 (gntCd) */
    async fetchGntCdMenu() {
      this.$store.commit('CODE/SET_GNT_CD_EMPTY');
      try {
        const dataLength = await this.$store.dispatch('CODE/FETCH_GNT_CD', {
          cmd: this.isReward ? 'gntCd' : 'gntCdApp',
          searchGntGubunCd: this.GET_GNT_GUBUN_CD,
        });

        if (dataLength === 0) this.emptyDataFlag = true;
        this.OFF_APP_SPINNER(); // 스피너 OFF
      } catch (error) {
        console.log(error);
      }
    },

    // 보상휴가 목록 조회
    async fetchRewardTime() {
      await this.$store.dispatch('ELA/FETCH_REWARD_LIST');
    },
  },
  created() {
    this.fetchGntCdMenu();
    if (this.isReward) {
      this.fetchRewardTime();
    }
  },
  mounted() {
    this.ON_APP_SPINNER(); // 스피너 ON
  },
  components: {
    ApplMenuIcon,
    NoApplicable,
  },
};
</script>
<style>
.row.title-wrap {
  margin-bottom: 10px;
}
.chip-wrap {
  padding: 0px 22px 20px;
}

.divider::before {
  margin: 0 10px;
}
</style>
